module.exports = __webpack_public_path__ + "static/media/audio.6b07b9a0.svg";